<template>
    <footer>
        <div class="container footer-content">
            <div class="footer-col">
                <h4>Productos</h4>
                <ul>
                    <li><a href="#" @click.prevent="getTop('salud-completa')">{{ $t('food.Seguros') }}</a></li>
                    <li><a href="#" @click.prevent="getTop('seguros-dentales')">{{ $t('food.deltal') }}</a></li>
                    <li><a href="#" @click.prevent="getTop2('aviso-legalck')">{{ $t('food.AvisoLegal') }}</a></li>
                    <!--<li><a href="#">Seguros de Vida</a></li>
                    <li><a href="#">Mascotas</a></li>-->
                </ul>
            </div>
            <div class="footer-col">
                <h4>Atención al Cliente</h4>
                <ul>
                    <li><a href="https://www.asisa.es/cuadro-medico" target="_blank">{{ $t('food.cuadro') }}</a></li>
                    <li><a href="#" @click.prevent="getTop2('ficha-producto')">{{ $t('calc.Producto') }}</a></li>
                    <!--<li><a href="#">Oficinas</a></li>-->
                    <li><a href="#" @click.prevent="getTop('home')">{{ $t('food.preguntas') }}</a></li>
                    <li><a href="https://www.unitseguros.com/baja-de-comunicaciones/" target="_blank">{{ $t('food.baja') }}</a></li>
                </ul>
            </div>
            <div class="footer-col">
                <h4>Legal</h4>
                <ul>
                    <li><a href="#" @click.prevent="getTop('aviso-legal')">{{ $t('food.AvisoLegal') }} web</a></li>
                    <li><a href="#" @click.prevent="getTop('politica-privacidad')">{{ $t('food.privacidad') }}</a></li>
                    <li><a href="#" @click.prevent="getTop('politica-cookies')">Cookies</a></li>
                    <li><a href="#" @click.prevent="getTop('blog')">Blog</a></li>
                </ul>
            </div>
            <div class="footer-brand">
                <p>&copy; 2025 {{ $t('food.derechos') }}.</p>
                <div class="institutional-logo"
                    style="margin-top: 20px; display: flex; justify-content: center; gap: 20px;">
                    <a href="https://www.unitseguros.com/oficina/murcia-cabezo-torres/#" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        class="logo-card">
                        <img src="/distr_autorizado.png" alt="Unit Seguros" style="border-radius: 4px;">
                        <span class="logo-text">{{ $t('nav.distribuidor') }}</span>
                    </a>
                    <img src="/logo.png" alt="Ministerio de Economía, Comercio y Empresa - Gobierno de España"
                        style="max-width: 200px; height: auto; background: white; padding: 10px;border-radius: 6px;">
                    <img src="/logoDGS.png" alt="DGS Logo"
                        style="max-width: 200px; height: auto; background: white; padding: 10px;border-radius: 6px;">
                </div>
            </div>
        </div>
        <div class="footer-seo">
                <p v-html="$t('food.foodseo')"></p>
                <p v-html="$t('food.foodseo2')"></p>
            </div>
        <div style="color: gray;font-size: 8pt;padding: 4pt;">V. 2.7.1</div>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter',
    computed:{
        currentLang() {
            return this.$route.params.lang || 'es'
        }
    },
    methods:{
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        getTop(url){
            //this.$router.push({ name: url, params: { lang: this.currentLang } })
            window.open(`/${this.currentLang}/${url}`, '_blank')
            this.scrollToTop()
        },
        getTop2(url){
            //this.$router.push({ name: url, params: { lang: this.currentLang }, query: { info: 'true' } })
            window.open(`/${this.currentLang}/${url}`, '_blank')
            this.scrollToTop()
        }
    }
}
</script>

<style scoped>
.footer-seo {
  background-color: transparent; /* Un poco más oscuro que el footer principal */
  padding: 20px 20px;
  border-top: 1px solid #2a4a7a;
  font-size: 0.75rem;
  color: #a0c4e8;
  line-height: 1.5;
  text-align: center;
}

.footer-seo a {
  color: #ffc107;
  text-decoration: none;
}

.footer-seo a:hover {
  text-decoration: underline;
}

.footer-seo strong {
  color: white;
}

.footer-bottom {
  background-color: #071c33;
  padding: 15px 0;
  text-align: center;
  font-size: 0.7rem;
  color: #6c8eb0;
}
/* Estilos para las pastillas de logos */
.institutional-logo {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
}

.logo-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 200px;
    background: white;
    padding: 10px;
    border-radius: 8px;
    text-decoration: none;
    transition: transform 0.2s;
}

.logo-card:hover {
    transform: translateY(-3px);
}

.logo-card img {
    max-width: 120px;
    height: auto;
}

.logo-text {
    font-size: 0.6rem;
    font-weight: 700;
    color: #1C4A8D;
    letter-spacing: 1px;
    margin-top: 6px;
    text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
    .logo-card {
        max-width: 150px;
        padding: 8px;
    }
    .logo-card img {
        max-width: 130px;
    }
    .logo-text {
        font-size: 0.5rem;
    }
}

@media (max-width: 550px) {
    .institutional-logo {
        gap: 12px;
    }
    .logo-card {
        max-width: 120px;
    }
    .logo-card img {
        max-width: 100px;
    }
}
</style>